// REST-Client für LLM-gestützte Helfer (heute: Autorun-Config-Entwurf).
// Spiegelt /api/llm/* aus routes_llm.py des maco-runner.

import type { AutorunCfg } from "@/api/autoruns";

export type DraftAutorunResponse = {
  config: AutorunCfg;
  warnings: string[];
};

export class LlmApiError extends Error {
  constructor(public status: number, public detail: string) {
    super(`LLM-API (${status}): ${detail}`);
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const { getToken } = await import("./auth");
  const token = getToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(init?.headers as Record<string, string> | undefined ?? {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(path, { ...init, headers });
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = await res.json();
      detail = body?.detail ?? detail;
    } catch { /* nicht JSON */ }
    throw new LlmApiError(res.status, detail);
  }
  return res.json() as Promise<T>;
}

export const llmApi = {
  /** "Beschreibe was der Autorun tun soll..." -> kompletter AutorunCfg-Entwurf. */
  draftAutorun: (prompt: string) =>
    request<DraftAutorunResponse>("/api/llm/draft-autorun", {
      method: "POST",
      body: JSON.stringify({ prompt }),
    }),
};
